import { gql } from 'apollo-boost'

const ADVANCED_PROBE_CRAWLING_SESSIONS = gql`
  query advancedProbeCrawlingSessions(
    $page: Int
    $pageSize: Int
    $type: MenuCrawlingSessionType
  ) {
    advancedProbeCrawlingSessions(
      page: $page
      pageSize: $pageSize
      type: $type
    ) {
      advancedProbeCrawlingSessions {
        id
        status
        createdDate
        createdById
        completedDate
        abortedDate
        abortedById
        totalMenuCount
        crawledMenuCount
        scrapedMenuCount
      }
      total
    }
  }
`

export default ADVANCED_PROBE_CRAWLING_SESSIONS
